import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useDialog } from "lib/@hooks/useDialog"
import { AuditModal } from "routes/regime/components/audit-modal"
import { useReviewDecisions } from "routes/schedule/compare/inline-approval-buttons/review-decisions"
import { PAYLOAD_STATUS_REJECTED } from "routes/audit/lib/audit-constants.mjs"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { ReviewRejectionBanner } from "./review-rejection-banner"

export function InlineRejectionEditor() {
    const {
        accepted,
        decisionPayload,
        auditPayload,
        referenceId,
        reviewReferenceId,
        reviewCycle,
        userName,
        setOptimisticDecision,
    } = useBoundContext()
    const decisions = useReviewDecisions()
    const editRejection = useDialog(
        <AuditModal
            title="Edit Rejection"
            label="Justification"
            field="reason"
            placeholder="Enter justification"
            okCaption="Save"
            audit={{ reason: decisionPayload?.reason }}
        />
    )

    const isRejected = accepted === false
    if (!isRejected || !decisionPayload?.reason) return null

    return <ReviewRejectionBanner onEdit={isFromCurrentCycle() ? edit : undefined} />

    function isFromCurrentCycle() {
        const recordedReferenceId = decisionPayload?.groupReviewId
        const recordedCycle = decisionPayload?.reviewCycle
        if (recordedReferenceId != null) return recordedReferenceId === reviewReferenceId
        if (recordedCycle != null) return Number(recordedCycle) === Number(reviewCycle)
        const wasJustCreatedThisSession = recordedReferenceId == null && recordedCycle == null
        return wasJustCreatedThisSession
    }

    async function edit() {
        const edited = await editRejection()
        if (!edited?.reason) return
        await saveReason(edited.reason)
    }

    async function saveReason(reason) {
        const previousDecision = decisionPayload
        const rejection = {
            ...auditPayload,
            status: PAYLOAD_STATUS_REJECTED,
            event: "tailoring!custom-schedule-reject",
            shortDescription: "Change Rejected",
            reason,
            userName,
            actionedOn: new Date().toISOString(),
        }
        setOptimisticDecision(rejection)
        try {
            await decisions.record({ referenceId, shortDescription: "Change Rejected", payload: rejection })
        } catch (error) {
            console.warn("Failed to update rejection reason:", error?.message ?? error)
            setOptimisticDecision(previousDecision)
            errorSnackbar("Failed to update rejection. Please try again.")
        }
    }
}
